import {type SafeHTMLString, SafeHTMLText} from '@github-ui/safe-html'
import {Box, Text} from '@primer/react'

type IterationItemProps = {
  startDate: string
  durationInDays: number
  titleHTML: string
}

export function IterationItem({startDate, durationInDays, titleHTML}: IterationItemProps) {
  const now = new Date()
  const iterationStartDate = new Date(startDate)
  const endDate = new Date(iterationStartDate.getTime() + durationInDays * 24 * 60 * 60 * 1000)
  const isCurrent = iterationStartDate <= now && now <= endDate
  const formatDate = (d: Date) => d.toLocaleDateString('en-US', {month: 'short', day: 'numeric'})

  return (
    <Box sx={{display: 'flex', flexDirection: 'row', columnGap: 1, rowGap: 0, flexWrap: 'wrap'}}>
      <Box sx={{display: 'flex', fontSize: 0, justifyContent: 'space-between'}}>
        <SafeHTMLText html={titleHTML as SafeHTMLString} />
      </Box>
      <>&#8226; </>
      <Text sx={{color: 'fg.muted', fontSize: 0}}>
        {`${formatDate(iterationStartDate)} - ${formatDate(endDate)}`} {isCurrent && <>&#8226; </>}
      </Text>
      {isCurrent && <Text sx={{color: 'accent.fg', fontSize: 0, fontWeight: '500'}}>Current</Text>}
    </Box>
  )
}

try{ IterationItem.displayName ||= 'IterationItem' } catch {}